export default class NonThrottledScheduledExecutor {
    isRunning: boolean;
    callback: (data) => void;
    delay: number;
    worker?: Worker | null;

    constructor(callbackFn: (data) => void, delay: number) {
        this.isRunning = false;
        this.callback = callbackFn;
        this.delay = delay;
    };

    start(userData,baseUrl) {
        if (this.isRunning) {
            return;
        }

        this.isRunning = true;
        // Code in worker.
        let workerCode = `onmessage = async function(e) {
            if (e.data.action === 'start') {
                try {
                   const response=await fetch(e.data.baseUrl+'/ChatAppApi/api/wglcs/getcannmessagesbyuserid_new', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            'Authorization': 'Bearer '+e.data.userData.accessToken.auth_token
                        },
                        body: JSON.stringify({  
                            userId: e.data.userData.userLoginData.userId,
                            languageId:e.data.userData.userLoginData?.languageId
                        })
                    })

                    const data = await response.json();
                    postMessage(data);

                } catch (error) {
                    postMessage({ error: error.message });
                }
            }
        }
    `;

        this.worker = new Worker(URL.createObjectURL(new Blob([workerCode], {
            type: 'text/javascript'
        })));

        this.worker.onmessage = (data) => {
            this.callback(data);
        };

        this.worker.postMessage({ action: 'start', userData: userData,baseUrl:baseUrl });
    };


    stop() {
        if (this.isRunning) {
            this.isRunning = false;
            this.worker?.terminate();
            this.worker = null;
        }
    };
};